/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateScheduleRequest = {
    properties: {
        companyId: {
    type: 'number',
    isRequired: true,
},
        departmentId: {
    type: 'number',
    isRequired: true,
},
        facilityId: {
    type: 'number',
},
        shiftId: {
    type: 'number',
},
        assignee: {
    type: 'number',
    isNullable: true,
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        startDate: {
    type: 'string',
    format: 'date-time',
},
        endDate: {
    type: 'string',
    format: 'date-time',
},
        status: {
    type: 'ScheduleStatus',
    isRequired: true,
},
        isUrgent: {
    type: 'boolean',
    isRequired: true,
},
        startTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        endTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
    },
};